var animateStickyBar = function(){
  var bar;

  var _init = function(){
    bar = document.getElementById('sticky-cta');

    if (bar) {
      _displayBar();    
    }
  }

  var _displayBar = function(){
    setTimeout(function(){
      bar.classList.add('visible');
      
      _hideBar();

    }, 3000);

  }

  var _hideBar = function(){
    setTimeout(function(){
      bar.classList.remove('visible');
    },8000);
  }



  return {
    init: _init
  }
}();

animateStickyBar.init();


// WEBPACK FOOTER //
// ./resources/assets/js/partials/AnimateStickyBar.js